import { getParticipationByGroup } from '@/service/participation'

const initialState = () => ({
  data: {
    loading: false,
    activeCount: undefined,
    confirmedCount: undefined,
    createdAt: null,
    invitedCount: 0,
    participationRate: undefined,
  },
})

const state = initialState()

const getters = {
  participation: state => state.data,
}

const actions = {
  getParticipationByGroup({ commit }, groupId) {
    commit('startLoadingParticipation')
    getParticipationByGroup(groupId).then(data => {
      commit('stopLoadingParticipation')
      commit('setParticipation', data)
    })
  },
}

const mutations = {
  setParticipation(state, data) {
    state.data = { ...initialState(), ...data }
  },
  startLoadingParticipation(state) {
    state.data.loading = true
  },
  stopLoadingParticipation(state) {
    state.data.loading = false
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
